import UserLoginComponent from "../components/UserLoginComponent";

export default UserLoginComponent;